(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8082,9008,2054,5272,8836,7480],{

/***/ 93445:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand",
      function () {
        return __webpack_require__(61903);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ BRAND; }
/* harmony export */ });
var BRAND = "One Kings Lane";


/***/ }),

/***/ 32054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DEFAULT_CHECKOUT_VARIANT": function() { return /* binding */ DEFAULT_CHECKOUT_VARIANT; },
/* harmony export */   "checkVariantNameIsSize": function() { return /* binding */ checkVariantNameIsSize; },
/* harmony export */   "formatPrice": function() { return /* binding */ formatPrice; },
/* harmony export */   "formatPriceRange": function() { return /* binding */ formatPriceRange; },
/* harmony export */   "formatPriceValue": function() { return /* binding */ formatPriceValue; },
/* harmony export */   "getCookieByName": function() { return /* binding */ getCookieByName; },
/* harmony export */   "getCustomerDetails": function() { return /* binding */ getCustomerDetails; },
/* harmony export */   "getCustomerOrderCount": function() { return /* binding */ getCustomerOrderCount; },
/* harmony export */   "getPriceOrPriceRange": function() { return /* binding */ getPriceOrPriceRange; },
/* harmony export */   "getWindowAgent": function() { return /* binding */ getWindowAgent; },
/* harmony export */   "priceValue": function() { return /* binding */ priceValue; },
/* harmony export */   "productClickGa": function() { return /* binding */ productClickGa; },
/* harmony export */   "productUpdateGA": function() { return /* binding */ productUpdateGA; },
/* harmony export */   "removeSpecialChars": function() { return /* binding */ removeSpecialChars; },
/* harmony export */   "sizeArray": function() { return /* binding */ sizeArray; },
/* harmony export */   "sleep": function() { return /* binding */ sleep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48080);






var getCustomerDetails = function() {
    try {
        var customerDetails = localStorage.getItem("customer");
        if (customerDetails) {
            var ref = JSON.parse(customerDetails), customerId = ref.customerId, customerEmail = ref.customerEmail;
            if ((typeof customerId === "number" || typeof customerId === "string") && typeof customerEmail === "string") {
                return {
                    customerId: customerId,
                    customerEmail: customerEmail
                };
            }
        }
    } catch (err) {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to get customer details from localStorage");
    }
    return {
        customerId: 0,
        customerEmail: ""
    };
};
var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var productClickGa = function(param) {
    var product = param.product, position = param.position, category = param.category;
    var sendToGA = function() {
        if (true) {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            // Define the event object with the correct structure.
            var eventData = {
                event: "productClick",
                ecommerce: {
                    visitorType: visitorType,
                    customerId: customerId,
                    click: {
                        actionField: {
                            list: kebabCase(category)
                        },
                        products: [
                            {
                                name: product.name,
                                id: product.variants[0].sku,
                                price: product.calculated_price,
                                brand: product.brand || "",
                                category: category,
                                variant: product.variants[0].id,
                                position: position
                            }
                        ]
                    }
                },
                customerEmail: customerEmail
            };
            // Push event data to the dataLayer with type safety.
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var productUpdateGA = function(lineItem, event, cartTotal) {
    var sendToGA = function() {
        try {
            var customer = getCustomerDetails();
            var customerId = customer === null || customer === void 0 ? void 0 : customer.customerId;
            var customerEmail = customer === null || customer === void 0 ? void 0 : customer.customerEmail;
            var visitorType = customerEmail ? "Logged In" : "Guest";
            var keyName = event === "addToCart" ? "add" : "remove";
            var _obj;
            // Create the correct GA event based on the input event type.
            var eventData = {
                event: event,
                ecommerce: (_obj = {
                    visitorType: visitorType,
                    customerId: customerId
                }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, keyName, {
                    products: [
                        {
                            name: lineItem.name,
                            // for grouped products like quilts, do you have a default that you can use?
                            id: lineItem.sku,
                            // for grouped products like quilts, do you have a default that you can use?
                            price: lineItem.originalPrice,
                            // for grouped products like quilts, do you have a default that you can use?
                            salePrice: lineItem.salePrice,
                            brand: lineItem.brand,
                            variant: lineItem.variantId,
                            quantity: lineItem.quantity
                        }
                    ]
                }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "customerEmail", customerEmail), _obj),
                cartTotal: cartTotal
            };
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                ecommerce: null
            }) // Clear the previous ecommerce object.
            ;
            window.dataLayer.push(eventData);
        } catch (err) {
            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to send GA event", err);
        }
    };
    if (window.loadedAndInteractive) {
        sendToGA();
    } else {
        window.addEventListener("loadedAndInteractive", sendToGA, {
            once: true
        });
    }
};
var getCustomerOrderCount = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var orderCountFromStorage, ref, getCustomer, getCustomerOrders, ref1, customer, success, orderCount;
        return _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    orderCountFromStorage = sessionStorage.getItem("customerOrderCount");
                    if (!(orderCountFromStorage !== null && orderCountFromStorage)) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", parseInt(orderCountFromStorage));
                case 3:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return (0,_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 7941).then(__webpack_require__.bind(__webpack_require__, 57941)),
                            __webpack_require__.e(/* import() */ 1950).then(__webpack_require__.bind(__webpack_require__, 41950)), 
                        ];
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    getCustomer = ref[0].getCustomer;
                    getCustomerOrders = ref[1].getCustomerOrders;
                    _ctx.next = 12;
                    return getCustomer();
                case 12:
                    ref1 = _ctx.sent;
                    customer = ref1.customer;
                    success = ref1.success;
                    if (!(!success || !customer)) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", 0);
                case 17:
                    _ctx.next = 19;
                    return getCustomerOrders({
                        sort: "date_created:desc"
                    });
                case 19:
                    orderCount = _ctx.sent.length;
                    sessionStorage.setItem("customerOrderCount", "".concat(orderCount));
                    return _ctx.abrupt("return", orderCount);
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCustomerOrderCount() {
        return _ref.apply(this, arguments);
    };
}();
var formatPrice = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // using parseFloat to make sure this function works for both number and string
    var floatPrice = parseFloat("".concat(price || ""));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return "$".concat(parseFloat("".concat(price || "")).toFixed(digit));
};
var formatPriceValue = function(price) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var floatPrice = parseFloat(String(price));
    if (!Number.isFinite(floatPrice)) {
        return price;
    }
    return Number(parseFloat(String(price)).toFixed(digit));
};
// using parseFloat to make sure this function works for both number and string
var formatPriceRange = function(minPrice, maxPrice) {
    var digit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return "".concat(formatPrice(minPrice, digit) || "", " - ").concat(formatPrice(maxPrice, digit) || "");
};
var getPriceOrPriceRange = function(product, priceType) {
    var ref;
    var variants = product.variants;
    var sortedVariantPrices = (ref = variants === null || variants === void 0 ? void 0 : variants.map(function(variant) {
        return parseFloat("".concat(variant[priceType]));
    })) === null || ref === void 0 ? void 0 : ref.sort();
    var minPrice = variants ? sortedVariantPrices[0] : product[priceType];
    var maxPrice = variants ? sortedVariantPrices.pop() : product[priceType];
    return minPrice === maxPrice ? formatPrice(minPrice) : formatPriceRange(minPrice, maxPrice);
};
var sizeArray = [
    "small",
    "medium",
    "large",
    "extra small",
    "extra large",
    "long",
    "tall",
    "short"
];
var checkVariantNameIsSize = function(el) {
    var name = el.option_values[0].label.toLowerCase();
    if (/^\d/.test(name) || sizeArray.includes(name)) {
        return true;
    }
    return false;
};
var priceValue = function(price) {
    return price.split("$")[1];
};
var removeSpecialChars = function(string) {
    var regex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : /[^a-zA-Z \s0-9,'\-#.*&]/g;
    return "".concat(string).replace(regex, "");
};
var getCookieByName = function(name, cookiesFromRequest) {
    var cookies;
    if (globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
        var _cookie;
        cookies = (_cookie = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document.cookie) !== null && _cookie !== void 0 ? _cookie : "";
    } else {
        cookies = cookiesFromRequest !== null && cookiesFromRequest !== void 0 ? cookiesFromRequest : "";
    }
    if (cookies) {
        var ref, ref1;
        var ref2;
        var cookieName = (ref2 = (ref = cookies.split(";")) === null || ref === void 0 ? void 0 : ref.find(function(cookie) {
            return cookie.includes(name);
        })) !== null && ref2 !== void 0 ? ref2 : "";
        return (ref1 = cookieName === null || cookieName === void 0 ? void 0 : cookieName.split("=")) === null || ref1 === void 0 ? void 0 : ref1[1];
    }
    return "";
};
// IDs for each variant within an experiment are numeric and indexed at 0
var DEFAULT_CHECKOUT_VARIANT = "0";
var sleep = function(ms) {
    return new Promise(function(r) {
        return setTimeout(r, ms);
    });
};
var getWindowAgent = function(nextContextReq) {
    // Ref: https://stackoverflow.com/questions/59494037/how-to-detect-the-device-on-react-ssr-app-with-next-js
    // if you are on the server and you get a 'nextContextReq' property from your context
    if (nextContextReq) {
        // get the user-agent from the headers
        return nextContextReq.headers["user-agent"];
    }
    // if you are on the client you can access the navigator from the window object
    return navigator.userAgent;
};


/***/ }),

/***/ 55272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getBloomreachConfig": function() { return /* binding */ getBloomreachConfig; }
/* harmony export */ });
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32054);
/* harmony import */ var _getRefererString__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84295);


var fallbackUserId = Array(15).fill(null).map(function() {
    return "8";
}).join("");
var getBloomreachConfig = function(cookies) {
    var useBloomreach = true // getCookieByName('useBloomreach', cookies) === '1'
    ;
    var bloomreachUID = (0,_common__WEBPACK_IMPORTED_MODULE_0__.getCookieByName)("_br_uid_2", cookies) || fallbackUserId;
    var url = "";
    if (true) {
        url = (0,_getRefererString__WEBPACK_IMPORTED_MODULE_1__.getCurrentUrl)(window === null || window === void 0 ? void 0 : window.location);
    }
    return {
        useBloomreach: useBloomreach,
        bloomreachUID: bloomreachUID,
        url: url
    };
};


/***/ }),

/***/ 28764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48080);






var kebabCase = function(str) {
    return "".concat(str || "").replace(/([a-z])([A-Z])/g, "$1-$2") // get all lowercase letters that are near to uppercase ones
    .replace(/[\s_]+/g, "-") // replace all spaces and low dash
    .toLowerCase();
};
var usePLPAnalytics = function(param) {
    var cart = param.cart, customer = param.customer, products = param.products, categoryName = param.categoryName, _plpType = param.plpType, plpType = _plpType === void 0 ? "category" : _plpType;
    var PLPAnalytics = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var ref, getCustomerOrderCount, cartTotal, customerId, customerEmail, impressions, orderCount, sendToGA;
        return _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (products) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.next = 6;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 2054).then(__webpack_require__.bind(__webpack_require__, 32054)), 
                        ];
                    });
                case 6:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 1);
                    getCustomerOrderCount = ref[0].getCustomerOrderCount;
                    cartTotal = (cart === null || cart === void 0 ? void 0 : cart.total.toFixed(2)) || 0;
                    customerId = (customer === null || customer === void 0 ? void 0 : customer.entityId) || 0;
                    customerEmail = (customer === null || customer === void 0 ? void 0 : customer.email) || "";
                    impressions = products.map(function(product, index) {
                        return {
                            name: product.name,
                            id: product.variants[0].sku,
                            price: product.calculated_price,
                            brand: product.brand,
                            category: categoryName,
                            variant: product.variants[0].id,
                            list: kebabCase(categoryName),
                            position: index + 1,
                            reviewCount: product.reviewCount,
                            reviewRating: product.reviewRating
                        };
                    });
                    _ctx.next = 15;
                    return getCustomerOrderCount();
                case 15:
                    orderCount = _ctx.sent;
                    sendToGA = function() {
                        var ref, ref1, ref2, ref3;
                        var collectionView = {
                            event: "collectionView",
                            ecommerce: {
                                currencyCode: "USD",
                                impressions: impressions,
                                customerEmail: customerEmail,
                                customerId: customerId,
                                visitorType: customerId ? "Logged In" : "Guest"
                            },
                            customerEmail: customerEmail,
                            pageName: "plp"
                        };
                        var customerEvent = {
                            event: "customer",
                            visitorType: customerId ? "Logged In" : "Guest",
                            customerId: customerId,
                            customerEmail: customerEmail,
                            customerOrdersCount: orderCount,
                            customerTotalSpent: "",
                            cartTotal: cartTotal,
                            pageType: plpType
                        };
                        window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : (ref1 = ref.push) === null || ref1 === void 0 ? void 0 : ref1.call(ref, collectionView);
                        window === null || window === void 0 ? void 0 : (ref2 = window.dataLayer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.push) === null || ref3 === void 0 ? void 0 : ref3.call(ref2, customerEvent);
                    };
                    if (window.loadedAndInteractive) {
                        sendToGA();
                    } else {
                        window.addEventListener("loadedAndInteractive", sendToGA, {
                            once: true
                        });
                    }
                    _ctx.next = 23;
                    break;
                case 20:
                    _ctx.prev = 20;
                    _ctx.t2 = _ctx["catch"](0);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("PLPAnalytics Error", _ctx.t2);
                case 23:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                20
            ]
        ]);
    })), [
        cart,
        customer,
        products,
        categoryName,
        plpType
    ]);
    return {
        PLPAnalytics: PLPAnalytics
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePLPAnalytics);


/***/ }),

/***/ 61903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_usePLPAnalytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28764);
/* harmony import */ var _services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38552);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27429);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48080);
/* harmony import */ var _data_constants_BRAND__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64474);
/* harmony import */ var _helpers_getBloomreachConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55272);
/* harmony import */ var _helpers_timePromiseAndLog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60599);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_11__);


















var Default = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 6872).then(__webpack_require__.bind(__webpack_require__, 16872)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16872)
            ];
        }
    }
});
var PLP = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8309), __webpack_require__.e(8764), __webpack_require__.e(8924), __webpack_require__.e(6465)]).then(__webpack_require__.bind(__webpack_require__, 56465)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56465)
            ];
        }
    }
});
var BrandPage = function(param) {
    var content = param.content, legacyId = param.legacyId, slug = param.slug, query = param.query, currentPage = param.currentPage, sitewideBanner = param.sitewideBanner, megaNav = param.megaNav, userAgent = param.userAgent, products = param.products, breadcrumbs = param.breadcrumbs, category = param.category, facets = param.facets, total = param.total, itemsPerPage = param.itemsPerPage, eventBanner = param.eventBanner, footer = param.footer, sort = param.sort;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,_services_getSiteWideInitialProps__WEBPACK_IMPORTED_MODULE_5__.useClientSideCartAndUser)(), cart = ref1.cart, setCart = ref1.setCart, user = ref1.user, reloadCustomer = ref1.reloadCustomer;
    var categoryName = (category === null || category === void 0 ? void 0 : category.name) || "";
    var PLPAnalytics = (0,_hooks_usePLPAnalytics__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        plpType: "brand",
        cart: cart,
        customer: user,
        products: products,
        categoryName: categoryName
    }).PLPAnalytics;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        PLPAnalytics();
    }, [
        products,
        cart,
        PLPAnalytics
    ]);
    var metaTags = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var description;
        if (!breadcrumbs || (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.length) === 0) {
            description = "";
        } else {
            description = breadcrumbs.slice(0).reverse().map(function(param) {
                var name = param.name;
                return name;
            }).concat(_data_constants_BRAND__WEBPACK_IMPORTED_MODULE_12__/* .BRAND */ .c).join(" | ");
        }
        var title = "".concat(categoryName, " | Brands | One Kings Lane");
        return {
            description: description,
            title: title
        };
    }, [
        breadcrumbs,
        categoryName
    ]);
    var baseHref = "/brand?slug=".concat(slug, "&legacyId=").concat(legacyId, "&");
    var baseUrl =  true ? "".concat(window.location.pathname, "?") : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Default, {
        shouldUsePageView: false,
        reloadCustomer: reloadCustomer,
        user: user,
        sitewideBanner: sitewideBanner,
        megaNav: megaNav,
        meta: metaTags,
        cart: cart,
        onUpdateCart: setCart,
        eventBanner: eventBanner,
        maybeFooterFromContentful: footer,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_11___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                    rel: "canonical",
                    href: "".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_10__.SHOP_ORIGIN).concat(String(category === null || category === void 0 ? void 0 : category.url))
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PLP, {
                user: user,
                reloadCustomer: reloadCustomer,
                itemsPerPage: itemsPerPage,
                baseHref: baseHref,
                baseUrl: baseUrl,
                currentPage: currentPage,
                products: products,
                showBreadcrumbs: !(content === null || content === void 0 ? void 0 : content.hideBreadcrumbs),
                breadcrumbs: breadcrumbs,
                PLPHeader: categoryName,
                totalNumberOfProducts: total,
                facets: facets,
                queryParam: query,
                plpBanner: content,
                userAgent: userAgent,
                isCategoryEvent: true,
                isLoading: isLoading,
                setIsLoading: setIsLoading,
                sortValue: sort,
                plpSource: "brand",
                plpSourceId: legacyId
            })
        ]
    });
};
var isNotBrandFacet = function(facet) {
    var ref;
    return ((ref = facet.name) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) !== "brand";
};
var _tmp;
_tmp = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx) {
        var ref, req, res, query, asPath, userAgent, legacyId, slug, queryWithoutSlug, path, currentPage, ref1, ref2, Content, getSiteWideInitialProps, getWindowAgent, getRefererString, fetchAndProcessCategoryPageProducts, getQueryXssEscaped, legalQuery, id, ref3, siteWideInitialProps, content, searchResponse, ref4, products, breadcrumbs, category, responseFacets, total, itemsPerPage, abScheduleEnabled, ref5, facets, ref6, SiteWideInitialPropsFailure;
        return _codebuild_output_src3615781054_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    req = ctx.req, res = ctx.res, query = ctx.query, asPath = ctx.asPath;
                    userAgent = "";
                    legacyId = Array.isArray(query === null || query === void 0 ? void 0 : query.legacyId) ? query === null || query === void 0 ? void 0 : (ref = query.legacyId) === null || ref === void 0 ? void 0 : ref[0] : (query === null || query === void 0 ? void 0 : query.legacyId) || "";
                    slug = query.slug, queryWithoutSlug = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(query, [
                        "slug"
                    ]);
                    path = "".concat(asPath || "").replace(/^(\/c-[a-z-]+)\//, "$1");
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_6__/* .log */ .cM)("Category Page getServerSideProps ".concat(JSON.stringify({
                        path: path,
                        asPath: asPath
                    })));
                    currentPage = parseInt("".concat(String((query === null || query === void 0 ? void 0 : query.page) || ""))) || 1;
                    _ctx.prev = 8;
                    ;
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z;
                    _ctx.next = 13;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 8993).then(__webpack_require__.bind(__webpack_require__, 98993)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38552)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 32054)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84295)),
                            Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(8309), __webpack_require__.e(8764), __webpack_require__.e(1724), __webpack_require__.e(5713), __webpack_require__.e(8721), __webpack_require__.e(2547)]).then(__webpack_require__.bind(__webpack_require__, 69013)),
                            Promise.all(/* import() */[__webpack_require__.e(8924), __webpack_require__.e(5622)]).then(__webpack_require__.bind(__webpack_require__, 55622)), 
                        ];
                    });
                case 13:
                    _ctx.t1 = _ctx.sent;
                    ref2 = (0, _ctx.t0)(_ctx.t1, 6);
                    Content = ref2[0].Content;
                    getSiteWideInitialProps = ref2[1].getSiteWideInitialProps;
                    getWindowAgent = ref2[2].getWindowAgent;
                    getRefererString = ref2[3].getRefererString;
                    fetchAndProcessCategoryPageProducts = ref2[4].fetchAndProcessCategoryPageProducts;
                    getQueryXssEscaped = ref2[5].getQueryXssEscaped;
                    legalQuery = getQueryXssEscaped(queryWithoutSlug);
                    userAgent = getWindowAgent(req) || userAgent;
                    id = "brand".concat((legalQuery === null || legalQuery === void 0 ? void 0 : legalQuery.id) || (legalQuery === null || legalQuery === void 0 ? void 0 : legalQuery.legacyId) || "");
                    _ctx.t2 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z;
                    _ctx.next = 27;
                    return Promise.all([
                        (0,_helpers_timePromiseAndLog__WEBPACK_IMPORTED_MODULE_9__/* .timePromiseAndLog */ .Q)("BrandPage.getInitialProps.getSiteWideInitialProps")(getSiteWideInitialProps(ctx)),
                        (0,_helpers_timePromiseAndLog__WEBPACK_IMPORTED_MODULE_9__/* .timePromiseAndLog */ .Q)("BrandPage.getInitialProps.Content.categoryPage")(Content.categoryPage({
                            id: legacyId
                        })),
                        (0,_helpers_timePromiseAndLog__WEBPACK_IMPORTED_MODULE_9__/* .timePromiseAndLog */ .Q)("BrandPage.getInitialProps.fetchAndProcessCategoryPageProducts")(fetchAndProcessCategoryPageProducts({
                            asPath: String(asPath || ""),
                            referer: getRefererString(req === null || req === void 0 ? void 0 : (ref1 = req.headers) === null || ref1 === void 0 ? void 0 : ref1.referer),
                            bloomreachConfig: (0,_helpers_getBloomreachConfig__WEBPACK_IMPORTED_MODULE_8__.getBloomreachConfig)(req === null || req === void 0 ? void 0 : req.headers.cookie),
                            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, legalQuery), {
                                id: id,
                                legacyId: id
                            })
                        }))
                    ]);
                case 27:
                    _ctx.t3 = _ctx.sent;
                    ref3 = (0, _ctx.t2)(_ctx.t3, 3);
                    siteWideInitialProps = ref3[0];
                    content = ref3[1];
                    searchResponse = ref3[2];
                    ref4 = searchResponse !== null && searchResponse !== void 0 ? searchResponse : {
                        abScheduleEnabled: false
                    }, products = ref4.products, breadcrumbs = ref4.breadcrumbs, category = ref4.category, responseFacets = ref4.facets, total = ref4.total, itemsPerPage = ref4.itemsPerPage, abScheduleEnabled = ref4.abScheduleEnabled;
                    if (abScheduleEnabled) {
                        ;
                        res === null || res === void 0 ? void 0 : (ref5 = res.setHeader) === null || ref5 === void 0 ? void 0 : ref5.call(res, "cache-control", "public, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0");
                    }
                    if (products === null || products === void 0 ? void 0 : products.length) {
                        _ctx.next = 40;
                        break;
                    }
                    res === null || res === void 0 ? void 0 : res.writeHead(302, {
                        Location: "/c/shop-sale?redirectFrom=".concat(encodeURIComponent(asPath || "/b-".concat(legacyId))),
                        "cache-control": "public, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0"
                    });
                    res === null || res === void 0 ? void 0 : res.end();
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_6__/* .log */ .cM)("No products found, sleeping for ".concat(15, "s"));
                    _ctx.next = 40;
                    return new Promise(function(resolve) {
                        return setTimeout(resolve, 15000);
                    });
                case 40:
                    facets = (responseFacets || []).filter(isNotBrandFacet);
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                        legacyId: legacyId,
                        slug: slug,
                        content: content,
                        query: legalQuery
                    }, siteWideInitialProps), {
                        sort: legalQuery === null || legalQuery === void 0 ? void 0 : legalQuery.sort,
                        path: path,
                        currentPage: currentPage,
                        userAgent: userAgent,
                        asPath: asPath,
                        products: products,
                        breadcrumbs: breadcrumbs,
                        category: category,
                        facets: facets,
                        total: total,
                        itemsPerPage: itemsPerPage
                    }));
                case 44:
                    _ctx.prev = 44;
                    _ctx.t4 = _ctx["catch"](8);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_6__/* .log */ .cM)("Cannot get initial props in category page, redirecting", _ctx.t4);
                    res === null || res === void 0 ? void 0 : res.writeHead(302, {
                        Location: "/",
                        "cache-control": "public, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0"
                    });
                    res === null || res === void 0 ? void 0 : res.end();
                case 49:
                    _ctx.t5 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z;
                    _ctx.next = 52;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38552))
                        ];
                    });
                case 52:
                    _ctx.t6 = _ctx.sent;
                    ref6 = (0, _ctx.t5)(_ctx.t6, 1);
                    SiteWideInitialPropsFailure = ref6[0].SiteWideInitialPropsFailure;
                    return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({
                        legacyId: legacyId,
                        slug: slug,
                        total: 0,
                        content: null,
                        query: {},
                        path: path,
                        currentPage: currentPage,
                        category: null,
                        products: [],
                        facets: [],
                        breadcrumbs: [],
                        itemsPerPage: 60
                    }, SiteWideInitialPropsFailure), {
                        userAgent: userAgent,
                        asPath: asPath
                    }));
                case 56:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                8,
                44
            ]
        ]);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}(), BrandPage.getInitialProps = _tmp, _tmp;
/* harmony default export */ __webpack_exports__["default"] = (BrandPage);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,8552,9774,2888,179], function() { return __webpack_exec__(93445); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);